





































































import { eventResponseStatus } from '../../enums/eventResponseStatus';
import CalendarEventResponseTypeInvitee from '../../../src/components/calendar/CalendarEventResponseTypeInvitee';
import Icon from '../../components/Icon.vue';
import { iconClassEnum } from '../../enums/iconClassEnum';
import IconContainer from '../../components/IconContainer.vue';
import { DateTimeUtil } from '../../utils/dateTimeUtil';
import { dateFormatEnum } from '../../enums/dateFormatEnum';
import AulaAlert from '../../components/AulaAlert.vue';
import { PropType } from 'vue';
import { EventData } from '../../../src/business/calendar/eventData';

export default {
  components: { AulaAlert, IconContainer, Icon, CalendarEventResponseTypeInvitee },
  props: {
    invitees: { type: Array, default: () => [] },
    groupHomeInvitees: { type: Array, default: () => [] },
    showParticipantInformation: { type: Boolean, default: false },
    eventData: { type: Object as PropType<EventData>, default: null },
  },
  emits: ['reminderSent'],
  computed: {
    iconClassEnum() {
      return iconClassEnum;
    },
    inviteeCount() {
      return this.invitees.length + this.groupHomeInvitees.length;
    },
    acceptedInvitees() {
      return this.invitees.filter(invitee => invitee.responseType === eventResponseStatus.ACCEPTED);
    },
    declinedInvitees() {
      return this.invitees.filter(invitee => invitee.responseType === eventResponseStatus.DECLINED);
    },
    tentativeInvitees() {
      return this.invitees.filter(invitee => invitee.responseType === eventResponseStatus.TENTATIVE);
    },
    waitingInvitees() {
      return this.invitees.filter(invitee => invitee.responseType === eventResponseStatus.WAITING);
    },
    acceptedGroupHomeInvitees() {
      return this.groupHomeInvitees.filter(invitee => invitee.responseType === eventResponseStatus.ACCEPTED);
    },
    declinedGroupHomeInvitees() {
      return this.groupHomeInvitees.filter(invitee => invitee.responseType === eventResponseStatus.DECLINED);
    },
    tentativeGroupHomeInvitees() {
      return this.groupHomeInvitees.filter(invitee => invitee.responseType === eventResponseStatus.TENTATIVE);
    },
    waitingGroupHomeInvitees() {
      return this.groupHomeInvitees.filter(invitee => invitee.responseType === eventResponseStatus.WAITING);
    },
    numberOfAdultParticipants() {
      return (
        this.acceptedInvitees.reduce((sum, invitee) => sum + invitee.numberOfAdultParticipants || 0, 0) +
        this.acceptedGroupHomeInvitees.reduce((sum, invitee) => sum + invitee.numberOfAdultParticipants || 0, 0)
      );
    },
    numberOfChildParticipants() {
      return (
        this.acceptedInvitees.reduce((sum, invitee) => sum + invitee.numberOfChildParticipants || 0, 0) +
        this.acceptedGroupHomeInvitees.reduce((sum, invitee) => sum + invitee.numberOfChildParticipants || 0, 0)
      );
    },
    acceptedInviteeCount() {
      return this.acceptedInvitees.length + this.acceptedGroupHomeInvitees.length;
    },
    declinedInviteeCount() {
      return this.declinedInvitees.length + this.declinedGroupHomeInvitees.length;
    },
    tentativeInviteeCount() {
      return this.tentativeInvitees.length + this.tentativeGroupHomeInvitees.length;
    },
    waitingInviteeCount() {
      return this.waitingInvitees.length + this.waitingGroupHomeInvitees.length;
    },
    acceptedParticipantInformation() {
      const textAnswered = this.$getText('CALENDAR_LABEL_EVENT_ANSWERS');
      const textAnd = this.$getText('AND');
      const textAdult = this.numberOfAdultParticipants === 1 ? this.$getText('ADULT') : this.$getText('ADULTS');
      const textChild =
        this.numberOfChildParticipants === 1 ? this.$getText('SMALL_CHILD') : this.$getText('SMALL_CHILDREN');
      return `(${this.acceptedInviteeCount} ${textAnswered}: ${this.numberOfAdultParticipants} ${textAdult} ${textAnd} ${this.numberOfChildParticipants} ${textChild})`;
    },
    lastReminderDateTime() {
      if (!this.eventData.lastReminderDateTime || !this.eventData.canOrganize) {
        return null;
      }
      return DateTimeUtil.formatDate(
        this.eventData.lastReminderDateTime,
        dateFormatEnum.LONG_DATE_TIME_WITH_DATE_PREFIX
      );
    },
  },
  methods: {
    emitReminderSent() {
      this.$emit('reminderSent');
    },
  },
};
